import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/app'
import { PostponedOrderNotification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { TFunction } from 'i18next'

export const getPostponedOrderProps = (
    notification: PostponedOrderNotification,
    t: TFunction<'app'>
) => {
    const title = t(`notification.title.${NotificationType.PostponedOrder}`)
    const description = t(`notification.description.${NotificationType.PostponedOrder}`, {
        orderShortCode: notification.orderShortCode,
    })

    return {
        title,
        orderShortCode: notification.orderShortCode,
        description,
    }
}
